
import { supabase } from "@/integrations/supabase/client";

export interface University {
  id: string;
  name: string;
  address: string;
  city: string;
  postcode: string;
  country: string;
}

export interface Lab {
  id: string;
  name: string;
  university_id: string;
}

export async function fetchUniversities(): Promise<University[]> {
  try {
    const { data, error } = await supabase
      .from('universities')
      .select('*')
      .order('name');

    if (error) {
      console.error('Error fetching universities:', error);
      return [];
    }

    return data || [];
  } catch (error) {
    console.error('Exception fetching universities:', error);
    return [];
  }
}

export async function fetchLabsByUniversity(universityId: string): Promise<Lab[]> {
  try {
    const { data, error } = await supabase
      .from('labs')
      .select('*')
      .eq('university_id', universityId)
      .order('name');

    if (error) {
      console.error('Error fetching labs:', error);
      return [];
    }

    return data || [];
  } catch (error) {
    console.error('Exception fetching labs:', error);
    return [];
  }
}

export async function addUniversity(university: Omit<University, 'id'>): Promise<University | null> {
  try {
    const { data, error } = await supabase
      .from('universities')
      .insert([university])
      .select()
      .single();

    if (error) {
      console.error('Error adding university:', error);
      return null;
    }

    return data;
  } catch (error) {
    console.error('Exception adding university:', error);
    return null;
  }
}

export async function addLab(lab: Omit<Lab, 'id'>): Promise<Lab | null> {
  try {
    const { data, error } = await supabase
      .from('labs')
      .insert([lab])
      .select()
      .single();

    if (error) {
      console.error('Error adding lab:', error);
      return null;
    }

    return data;
  } catch (error) {
    console.error('Exception adding lab:', error);
    return null;
  }
}
